module.exports = __webpack_public_path__ + "img/21.8.TSS.ed238477.png";